'use strict';

require('lazysizes/plugins/object-fit/ls.object-fit');

require('lazysizes/plugins/parent-fit/ls.parent-fit');

require('lazysizes/plugins/rias/ls.rias');

require('lazysizes/plugins/bgset/ls.bgset');

require('lazysizes');

require('lazysizes/plugins/respimg/ls.respimg');

require('../../styles/theme.scss');

require('../../styles/theme.scss.liquid');

var _themeA11y = require('@shopify/theme-a11y');

//import {cookiesEnabled} from '@shopify/theme-cart';

// Common a11y fixes
(0, _themeA11y.focusHash)();
(0, _themeA11y.bindInPageLinks)();

// Apply a specific class to the html element for browser support of cookies.
/*
if (cookiesEnabled()) {
  document.documentElement.className = document.documentElement.className.replace(
    'supports-no-cookies',
    'supports-cookies',
  );
}
*/

$(document).ready(function () {
    var $window = $(window);

    $.fn.init_scroll = function () {

        var $toolbar = $('.site-notification');
        var $toolbar_height = $toolbar.length ? $toolbar.innerHeight() : 0;

        var setup_fixed = function setup_fixed() {

            if ($window.scrollTop() > $toolbar_height) {
                $('body').not('.sticky').addClass('sticky');
            } else {
                $('body').removeClass('sticky');
            }
        };
        $window.scroll(function (e) {
            setup_fixed();
        });
        setup_fixed();
    };

    $('body').init_scroll();

    $('.site-header__menu-toggle').on('click', function () {
        //$( '.site-header' ).toggleClass( 'show-nav' );
        $('body').toggleClass('show-nav');
    });

    $('.site-header__search-toggle').on('click', function () {
        if ($('.site-header').hasClass('show-search')) {
            $('.site-header').removeClass('show-search');
        } else {
            $('.site-header').addClass('show-search');
            $('body').removeClass('show-nav');
        }
    });
    $('.site-header__search .close').on('click', function () {
        $('.site-header').removeClass('show-search');
    });

    var setup_hover_intent = function setup_hover_intent() {

        if ($window.width() > 768) {

            $('.site-header__nav > ul > li a.shop').unbind('click');
        } else {

            $('.site-header__nav > ul > li a.shop').unbind('click');

            //setup click on shop, collection
            $('.site-header__nav > ul > li a.shop').on('click', function (event) {
                event.preventDefault();
                var $obj = $(this);
                var parent = $obj.parent();
                var megamenu = parent.find('.megamenu');
                if (megamenu.is(':visible')) {
                    megamenu.slideUp();
                } else {
                    megamenu.slideDown();
                }
                //console.log('tuta');
            });
            //                $('.site-header__nav .has-childs a').on('click', function(event){
            //                    event.preventDefault();
            //                    var $obj = $(this);
            //                    var parent = $obj.parent();
            //                    var sub_menu= parent.find('ul');
            //                    if(sub_menu.is(':visible')){
            //                        sub_menu.slideUp();
            //                        $obj.removeClass('open');
            //                    }else{
            //                        sub_menu.slideDown();
            //                        $obj.addClass('open');
            //                    }
            //                });
        }
    };

    setup_hover_intent();

    $window.resize(function (e) {
        setup_hover_intent();
    });

    //    var feed = new Instafeed({
    //        get: 'user',
    //        userId: 6738892994,
    //        accessToken: '6738892994.57d03ca.3753d3ede76b44ca9ea665f7288cc777',
    //        target: 'instafeed',
    //        resolution: 'standard_resolution',
    //        limit: 6,
    //        template: '<div class="item"><a href="{{link}}" style="background-image: url({{image}})" target="_blank"></a></div>',
    //        after: function() {
    //
    //        }
    //    });
    //    feed.run();

    //    $('.slideshow__items' ).slick( {
    //        fade: true,
    //        dots: true,
    //        arrows: false,
    //        autoplay: false,
    //        autoplaySpeed: $('.slideshow' ).data('autoplay-speed'),
    //        appendDots: '.slideshow__nav-wrapper'
    //    } );

    $('.product-item__images').each(function () {
        var $obj = $(this);
        if ($obj.find('.product-item__image').length > 1) {
            $obj.slick({
                fade: true,
                dots: true,
                arrows: true
            });

            $obj.on('mouseenter', function () {
                $obj.slick('slickNext');
            });
        }
    });

    $.fn.init_page_lookbook = function () {
        $(this).each(function () {
            var $fn = $(this);

            var popup = $('.lookbook-images-popup', $fn);

            var slick_initialized = false;
            var slick = null;

            $('.lookbook-images__item').on('click', function () {
                var $item = $(this);
                var index = $('.lookbook-images__item').index($item);

                popup.fadeIn('slow', function () {

                    if (slick_initialized === false) {
                        slick = $('.lookbook-images-popup__items').slick({
                            fade: false,
                            dots: false,
                            arrows: true,
                            mobileFirst: true,

                            responsive: [{
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 1,
                                    infinite: true,
                                    centerMode: true,
                                    //variableWidth: true,
                                    focusOnSelect: true,
                                    centerPadding: 0,
                                    speed: 500,
                                    initialSlide: index
                                }
                            }]
                        });
                        slick_initialized = true;
                    } else {
                        slick.slick('slickGoTo', index);
                    }
                });
                $('body').addClass('lookbook-images-popup-opened');
            });
            $('.lookbook-images-popup__close').on('click', function () {
                popup.fadeOut();
                $('body').removeClass('lookbook-images-popup-opened');
            });
            //
        });
    };

    $('.page-lookbook').init_page_lookbook();

    $.fn.init_faq = function () {
        $(this).each(function () {
            var $fn = $(this);

            var $content = $('.page-faq__content .shopify-section', $fn);
            var $navigation = $('.page-faq__navigation li');

            $navigation.on('click', function () {
                var $li = $(this);

                if ($li.hasClass('active')) {
                    return;
                }

                var index = $navigation.index($li);
                $content.eq(index).addClass('active');
                $content.eq(index).siblings().removeClass('active');
                $li.addClass('active');
                $li.siblings().removeClass('active');
            });

            $('.page-faq__info-item-question', $fn).on('click', function () {
                var $item = $(this).parent();
                if ($item.hasClass('active')) {
                    return;
                }
                $item.addClass('active');
                $item.siblings().removeClass('active');
            });
        });
    };
    $('.page-faq').init_faq();

    $('.page-shop__order-selector-title').on('click', function () {
        var $obj = $(this);
        if ($obj.next().is(':visible')) {
            $obj.next().slideUp();
        } else {
            $obj.next().slideDown();
        }
    });
    $('.page-shop__nav>ul>li.has-childs>a').on('click', function () {
        var $obj = $(this);
        var parent = $obj.parent();
        if (parent.hasClass('open')) {
            parent.removeClass('open');
        } else {
            parent.addClass('open');
        }
        return false;
    });

    $.fn.init_terms = function () {
        $(this).each(function () {
            var $fn = $(this);

            var $navigation = $('.page-terms__navigation>ul>li');
            var $content = $('.page-terms__content .shopify-section', $fn);

            $navigation.on('click', function () {
                var $li = $(this);

                if (!$li.hasClass('active')) {
                    var index = $navigation.index($li);
                    $content.eq(index).addClass('active');

                    $content.eq(index).siblings().removeClass('active');
                    $li.addClass('active');
                    $li.siblings().removeClass('active');
                    $li.siblings().find('.nav').html('');
                }

                var $investment_packages = $('.page-terms__content .shopify-section.active');

                //                const offsetTop = $investment_packages.offset().top - 500;
                //                $("html, body").animate({ scrollTop: offsetTop });

                tocbot.destroy();
                tocbot.init({
                    // Where to render the table of contents.
                    tocSelector: '.page-terms__navigation li.active .nav',
                    // Where to grab the headings to build the table of contents.
                    contentSelector: '.page-terms__content .shopify-section.active',
                    // Which headings to grab inside of the contentSelector element.
                    headingSelector: 'h1, h2, h3'
                });
            }).filter(":first").trigger('click');

            //            $( '.page-terms__navigation', $fn ).tacky( {
            //                parentSelector: '.page-terms__navigation .item-title',
            //                activeClass: 'active1'
            //            } );
            //            console.log($('#shopify-section-footer').innerHeight());
            //            $(".page-terms__navigation").sticky({
            //                topSpacing:0,
            //                bottomSpacing: $('#shopify-section-footer').outerHeight()
            //            });

            var a = new StickySidebar('#sidebar', {
                topSpacing: 60,
                bottomSpacing: 0,
                containerSelector: '.page-terms__wrapper',
                innerWrapperSelector: '.page-terms__navigation',
                resizeSensor: true
            });
        });
    };
    $('.page-terms').init_terms();

    $.fn.init_cart = function () {
        $(this).each(function () {
            var $fn = $(this);

            var $content = $('.page-faq__content .shopify-section', $fn);
            var $navigation = $('.page-faq__navigation li');

            $.fn.init_quantity = function () {
                $(this).each(function () {
                    var $quantity = $(this);
                    var $minus = $quantity.find('.minus');
                    var $input = $quantity.find('input');
                    var $plus = $quantity.find('.plus');

                    $minus.on('click', function () {
                        var current_val = parseInt($input.val());
                        if (current_val >= 2) {
                            $input.val(current_val - 1);
                        }
                    });
                    $plus.on('click', function () {
                        var current_val = parseInt($input.val());
                        $input.val(current_val + 1);
                    });
                });
            };
            $('.page-cart__product-quantity').init_quantity();
        });
    };
    $('.page-cart').init_cart();

    $.fn.init_homepage_shop_by_style = function () {
        $(this).each(function () {
            var $fn = $(this);

            var $content = $('.homepage-shop-by-style__products-wrapper', $fn);
            var $navigation = $('.homepage-shop-by-style__navigation li', $fn);

            $navigation.on('click', function () {
                var $li = $(this);

                if ($li.hasClass('active')) {
                    return;
                }
                var index = $navigation.index($li);
                $content.eq(index).show();
                $content.eq(index).siblings().hide();

                $li.addClass('active');
                $li.siblings().removeClass('active');

                $content.eq(index).find('.homepage-shop-by-style__products').slick({

                    mobileFirst: true,
                    variableWidth: true,
                    infinite: true,
                    arrows: false,

                    responsive: [{
                        breakpoint: 768,
                        settings: {
                            arrows: true,
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            variableWidth: false
                        }
                    }]
                });
            }).filter(':first').trigger('click');
        });
    };
    $('.homepage-shop-by-style').init_homepage_shop_by_style();

    $.fn.init_newsletter_popup = function () {
        $(this).each(function () {
            var $fn = $(this);

            var popupEnable = $fn.data('enable'),
                id = $fn.data('id'),
                showDelay = $fn.data('show-delay'),
                showAgainDelay = $fn.data('show-again-delay'),
                homepageLimit = $fn.data('homepage-limit'),
                visitorLimit = $fn.data('visitor-limit'),
                isVisitor = $fn.data('visitor'),
                showFor = $fn.data('show-for');

            var cookieName = 'newsletter_popup_' + id;

            var $errors = $fn.find('.errors');
            if ($errors.length) {
                showDelay = 0;
            }

            var showPopup = function showPopup() {
                var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;


                // Disable popup if "only enable for visitor" and customer
                if (visitorLimit == true && isVisitor == false) {
                    popupEnable = false;
                }
                // Check to see if the cookie exists

                if ($.cookie(cookieName)) {
                    popupEnable = false;
                }

                // Check for homepage limit
                if (homepageLimit && !$('body').hasClass('template-index')) {
                    popupEnable = false;
                }

                if (force) {
                    popupEnable = true;
                }

                // Check for errors to show the popup anyways
                //                var $errors = $fn.find('.errors');
                //                var formTags = getQueryString('contact%5Btags%5D');
                //
                //                if ($errors.length && formTags.includes('popup')) {
                //                  popupEnable = true;
                //                  $fn.find('input#email').addClass('errors');
                //                }

                if (popupEnable) {
                    $fn.addClass('open');

                    $.cookie(cookieName, 'shown', {
                        expires: showAgainDelay,
                        path: '/'
                    });
                }
            };
            var closePopup = function closePopup() {
                $fn.removeClass('open');
            };

            var popupTimeout = setTimeout(function () {
                var windowWidth = $(window).width();
                switch (showFor) {
                    case 'mobile':
                        if (windowWidth <= 768) {
                            showPopup();
                        }
                        break;
                    case 'desktop':
                        if (windowWidth > 768) {
                            showPopup();
                        }
                        break;
                    case 'both':
                        showPopup();
                        break;
                }
            }, showDelay);

            $('.site-footer__newsletter-link').on('click', function () {
                showPopup(true);
                return false;
            });
            $('.newsletter-popup__close,.newsletter-popup .no-thanks').on('click', function () {
                closePopup();
                return false;
            });
        });
    };
    $('.newsletter-popup').init_newsletter_popup();

    var sliding_popup = $('.sliding-popup');
    $(window).scroll(function () {
        if ($(window).scrollTop() + $(window).height() == $(document).height()) {
            sliding_popup.addClass('open');
        }
    });
    $('.sliding-popup .close').on('click', function () {
        sliding_popup.removeClass('open');
        return false;
    });
});